import { customGet, customPost } from "../../api/customApi";
import entityType from "../../api/entityType";
import genericActionType from "../../api/genericActionType";
import { Actions } from "./companyConstants";
import { downloadFile } from "../../utils/downloadFile";

export const readAction = (companyKey) => async (dispatch) => {
  dispatch({ type: Actions.READ_COMPANY });
  const payload = await customGet(entityType.COMPANY, genericActionType.READ, {
    params: {
      companyKey: companyKey,
    },
  });
  dispatch({ type: Actions.READ_COMPANY_SUCCEEDED, payload });
};

export const updateAction = (values) => async (dispatch) => {
  dispatch({ type: Actions.UPDATE_COMPANY });
  const payload = await customPost(
    entityType.COMPANY,
    genericActionType.UPDATE,
    values,
  );
  dispatch({ type: Actions.UPDATE_COMPANY_SUCCEEDED, payload });
};

export const uploadContractAction =
  (file, companyKey) => async (dispatch) => {
    dispatch({ type: Actions.UPLOAD_CONTRACT });
    try {
      const request = await customPost(
        entityType.COMPANY,
        "UploadContract",
        file,
        {
          file: true,
          params: { companyKey: companyKey },
          shouldThrow: true,
        },
      );

      if (!request.ok) {
        const errorResponse = await request.json();
        dispatch({
          type: Actions.UPLOAD_CONTRACT_SUCCEEDED,
          payload: errorResponse,
        });
        return;
      }

      const payload = await request.json();
      dispatch({ type: Actions.UPLOAD_CONTRACT_SUCCEEDED, payload });
    } catch (e) {
      console.log(e);
      dispatch({
        type: Actions.UPLOAD_CONTRACT_SUCCEEDED,
        payload: {
          Operation: {
            Outcome: "Error",
            Message:
              "An error occurred while uploading the contract file. Please contact support.",
          },
        },
      });
    }
  };

export const downloadContractAction = (companyKey, fileName) => async () => {
  try {
    const response = await customGet("Company", "DownloadContract", {
      params: { companyKey, fileName },
      blob: true,
    });
    const blob = await response.blob();
    downloadFile(blob, fileName);
  } catch (error) {
    console.error("Failed to download contract:", error);
  }
};

export const clearOperationResultAction = () => async (dispatch) => {
  dispatch({ type: Actions.CLEAR_OPERATION_RESULT });
};

// ── Subscriptions ──

export const listSubscriptionsAction = (companyKey) => async (dispatch) => {
  dispatch({ type: Actions.LIST_SUBSCRIPTIONS });
  const payload = await customGet(entityType.COMPANY, "ListSubscriptions", {
    params: { companyKey },
  });
  dispatch({ type: Actions.LIST_SUBSCRIPTIONS_SUCCEEDED, payload });
};

export const upsertSubscriptionAction = (model) => async (dispatch) => {
  dispatch({ type: Actions.UPSERT_SUBSCRIPTION });
  const payload = await customPost(
    entityType.COMPANY,
    "UpsertSubscription",
    model,
  );
  dispatch({ type: Actions.UPSERT_SUBSCRIPTION_SUCCEEDED, payload });
};

export const deleteSubscriptionAction = (model) => async (dispatch) => {
  dispatch({ type: Actions.DELETE_SUBSCRIPTION });
  const payload = await customPost(
    entityType.COMPANY,
    "DeleteSubscription",
    model,
  );
  dispatch({ type: Actions.DELETE_SUBSCRIPTION_SUCCEEDED, payload });
};

// ── Pricing Schedules ──

export const listPricingSchedulesAction = (companyKey) => async (dispatch) => {
  dispatch({ type: Actions.LIST_PRICING_SCHEDULES });
  const payload = await customGet(entityType.COMPANY, "ListPricingSchedules", {
    params: { companyKey },
  });
  dispatch({ type: Actions.LIST_PRICING_SCHEDULES_SUCCEEDED, payload });
};

export const createPricingScheduleAction = (formData, companyKey) => async (dispatch) => {
  dispatch({ type: Actions.CREATE_PRICING_SCHEDULE });
  try {
    const url = `${process.env.REACT_APP_API_URI}/Company/CreatePricingSchedule?companyKey=${companyKey}`;
    
    const { getApiFetch } = await import("../../api/getApiFetch");
    const apiFetch = getApiFetch();
    
    const response = await apiFetch(url, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      const errorResponse = await response.json();
      dispatch({
        type: Actions.CREATE_PRICING_SCHEDULE_SUCCEEDED,
        payload: errorResponse,
      });
      return;
    }

    const payload = await response.json();
    dispatch({ type: Actions.CREATE_PRICING_SCHEDULE_SUCCEEDED, payload });
  } catch (e) {
    console.error("Create pricing schedule error:", e);
    dispatch({
      type: Actions.CREATE_PRICING_SCHEDULE_SUCCEEDED,
      payload: {
        Operation: {
          Outcome: "Error",
          Message: "Failed to create pricing schedule.",
        },
      },
    });
  }
};

export const updatePricingScheduleAction = (formData, companyKey) => async (dispatch) => {
  dispatch({ type: Actions.UPDATE_PRICING_SCHEDULE });
  try {
    const url = `${process.env.REACT_APP_API_URI}/Company/UpdatePricingSchedule?companyKey=${companyKey}`;
    
    const { getApiFetch } = await import("../../api/getApiFetch");
    const apiFetch = getApiFetch();
    
    const response = await apiFetch(url, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      const errorResponse = await response.json();
      dispatch({
        type: Actions.UPDATE_PRICING_SCHEDULE_SUCCEEDED,
        payload: errorResponse,
      });
      return;
    }

    const payload = await response.json();
    dispatch({ type: Actions.UPDATE_PRICING_SCHEDULE_SUCCEEDED, payload });
  } catch (e) {
    console.error("Update pricing schedule error:", e);
    dispatch({
      type: Actions.UPDATE_PRICING_SCHEDULE_SUCCEEDED,
      payload: {
        Operation: {
          Outcome: "Error",
          Message: "Failed to update pricing schedule.",
        },
      },
    });
  }
};

export const deletePricingScheduleAction = (model) => async (dispatch) => {
  dispatch({ type: Actions.DELETE_PRICING_SCHEDULE });
  const payload = await customPost(
    entityType.COMPANY,
    "DeletePricingSchedule",
    model,
  );
  dispatch({ type: Actions.DELETE_PRICING_SCHEDULE_SUCCEEDED, payload });
};
